import React, {Component} from "react";
import './PopUpYesNo.css'
import SniperCamButton from "./SniperCamButton";

export default class PopUpYesNo extends Component {
    constructor(props) {
        super(props);
        this.text = props.text
        this.callback_function = props.callback_function
    }

    render() {
        return (
            <div className={'popUpYesNoOverlay'}>
                <div className={'popUpBoxYesNo'}>
                    <h1 className={'popUpYesNoText'}>{this.text}</h1>
                    <SniperCamButton onClick={() => {
                        if (this.callback_function) {
                            this.callback_function(true)
                        }
                    }} text="Yes" button_type={'GreenButton'} large={true}/>
                    <SniperCamButton onClick={() => {
                        if (this.callback_function) {
                            this.callback_function(false)
                        }
                    }} text={'No'} button_type={'RedButton'} large={true}/>
                </div>
            </div>
        );
    }
}